import axios from 'axios';
import { API_BASE_URL } from '../../../../lib/constants';

export const fetchPreOpChecklistData = async (uhid_no) => {
  const response = await axios.get(`${API_BASE_URL}/get_pre_operative_checklist/${uhid_no}`);
  return response.data;
};

export const fetchPatientData = async (uhid_no) => {
  const response = await axios.get(`${API_BASE_URL}/get_patient/${uhid_no}`);
  return response.data;
};

export const fetchPreOpNextIp = async () => {
    const response = await axios.get(`${API_BASE_URL}/get_preop_next_ip`);
    return response.data;
};

export const savePreOpChecklist = async (data) => {
  const response = await axios.post(`${API_BASE_URL}/pre_operative_checklist`, data);
  return response.data;
};

export const updatePreOpChecklist = async (uhid_no, data) => {
  const response = await axios.put(`${API_BASE_URL}/update_pre_operative_checklist/${uhid_no}`, data);
  return response.data;
};
